<template>
  <div class="game_item" @click="playGame">
    <div
      class="game_img"
      :class="{
        mengBane: item.is_maintenance
      }"
    >
      <img class="iemgses" :src="aoarrnimym" alt="" />
      <div class="fFW_uHsQoM95EC6sknGg"></div>
      <img
        class="is_maintenance"
        v-if="item.is_maintenance"
        src="./../../assets/icons/images/img_whz_style_1.webp"
        alt=""
      />

      <div v-if="item.favorable" class="gy98qRcKCBtFIJuUTF8N">BEST</div>
      <div
        class="rQ13hS2C2xOiatmUjuvy"
        v-if="item.type == 'game'"
        @click.stop="favorite"
      >
        <svg-icon
          class="comnenGMens_ssme"
          v-if="item.is_favorite == 0 || is_favorite == 0"
          icon-class="icon_dtfl_sc_3--svgSprite:all"
        />
        <svg-icon
          class="comnenGMens_ssme"
          :style="{ color: 'var(--skin__primary)' }"
          v-if="item.is_favorite == 1 || is_favorite == 1"
          icon-class="icon_dtfl_sc_3--svgSprite:all"
        />
      </div>
      <!-- BEST -->
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <svg-icon
          style="
            width: 100%;
            height: 100%;
            color: var(--theme-game-card-ddt_icon);
          "
          icon-class="img_mryx_card--svgSprite:all"
        />
      </div>
      <div class="comnenGMens" loading="loading">
        <div class="eocnmesMens">
          <img class="conte_img" v-lazy="item.image" alt="" />
        </div>
      </div>
      <div class="conemNsmens">
        <div>
          <p v-if="$store.state.config.show_game_name && item.type != 'platform'" class="_top-name_1tpv4_23">
            {{ item.name }}
          </p>
          <p class="_bottom-name_1tpv4_38">{{ item.class }}</p>
        </div>
      </div>
      <!-- vyJOQO76ijmamNiW1_eF -->
      <!-- <div class="vyJOQO76ijmamNiW1_eF" v-if="item.type!='platform'"></div> -->
      <!-- <div class="vyJOQO76ijmamNiW1_eF" v-if="item.type!='platform'">{{item.class}}</div> -->
    </div>
  </div>
</template>

<script>
// favoriteGame
import { favoriteGame } from '@/apis/modules/home.js';
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
  name: 'GameItem',
  props: {
    item: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'subgame'
    },
    category: {
      type: String,
      default: 'slot'
    }
  },
  data() {
    return {
      is_favorite: false,
      aoarrnimym: require('./../../assets/4Ddian/aoarr-nimym.png'),
      rememberPassword: window.localStorage.getItem('rememberPassword')
    };
  },
  computed: {
    ...mapState(['vuex_token_head'])
  },
  methods: {
    checkLogin() {
      if (!this.vuex_token_head) {
        if (this.rememberPassword && this.rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      return true;
    },
    favorite() {
      if (!this.checkLogin()) return false;
      favoriteGame({
        game_id: this.item.id,
        is_favorite: this.item.is_favorite == 0 ? 1 : 0
      }).then(({ code }) => {
        this.item.is_favorite = this.item.is_favorite == 0 ? 1 : 0;
        this.is_favorite = this.item.is_favorite;
        // this.is_favorite=
      });
    },
    playGame(id) {
      if (this.item.is_maintenance) {
        Toast.fail({
          message: this.myLineBreaks(this.$t('_home._tis')),
          duration: 1000
        });
        return false;
      }
      if (this.item.type != 'platform') {
        if (!this.checkLogin()) return false;
        if (
          this.$store.state.config.play_need &&
          this.$store.state.config.play_need[0] == 1
        ) {
          // 余额最低要求
          if (
            this.$store.state.config.play_need[1] >
            this.$store.state.moneyInfo.balance_coin
          ) {
            Toast.fail({
              message:
                this.$t('_home._balanceLess1') +
                this.$store.state.config.play_need[1] +
                this.$t('_home._balanceLess2'),
              duration: 1500
            });
            return false;
          }
        } else if (
          this.$store.state.config.play_need &&
          this.$store.state.config.play_need[0] == 2
        ) {
          // 充值最低要求
          if (
            this.$store.state.config.play_need[1] >
            this.$store.state.moneyInfo.recharge_total
          ) {
            Toast.fail({
              //message:this.$t('_home._rechargeLess1'),
              message:
                this.$t('_home._rechargeLess2') +
                this.$store.state.config.play_need[1] +
                this.$t('_home._rechargeLess3'),
              duration: 1500
            });
            return false;
          }
        }
      }
      // platform平台（点击跳游戏列表），
      // game游戏（点击后跳到玩游戏）
      if (this.item.type == 'platform') {
        // webview
        //
        if (this.type == 'home') {
          this.$router.push({
            name: 'subgame',
            query: {
              id: this.item.id,
              code: this.item.code,
              category: this.item.category || 'slot'
            }
          });
        }
        return false;
      } else {
        this.$router.push({
          name: 'webview',
          query: {
            id: this.item.id,
            category: this.item.category
            // =demo
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.game_item {
  width: 33.33%;
  display: flex;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
}

.mengBane .fFW_uHsQoM95EC6sknGg {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0;
  bottom: 0;
  cursor: not-allowed;
  left: 0;
  opacity: 1;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  -webkit-transition: opacity 0.6s;
  transition: opacity 0.6s;
  z-index: 9;
}
.game_item {
  --card-benchmark: 2.1rem;
  --advertisement-box-width: var(--card-benchmark);
  --advertisement-box-height: calc(var(--card-benchmark) * 1.33);
  --advertisement-box-border-width: 0;
  --advertisement-box-border-color: var(--theme-game-lobby-border);
  --advertisement-box-border-radius: 0.2rem;
  --game-platform-name-height: calc(var(--card-benchmark) * 0.25);
  --game-platform-name-padding: 0 calc(var(--card-benchmark) * 0.05)
    calc(var(--card-benchmark) * 0.05);
  --game-platform-name-font-size: calc(var(--card-benchmark) * 0.113);
  --label-game-status-width: calc(var(--card-benchmark) * 0.2);
  --label-game-status-height: calc(var(--card-benchmark) * 0.15);
  --favorited-icon-top: calc(var(--card-benchmark) * 0.033);
  --favorited-icon-right: calc(var(--card-benchmark) * 0.033);
  --favorited-icon-bottom: initial;
  --favorited-icon-left: initial;
  --favorited-icon-side: calc(var(--card-benchmark) * 0.206);
  --click-arean-expand-size: -0.06rem;
  --baseRadius: calc(var(--card-benchmark) * 0.09);
  --poster-box-border-radius: var(--baseRadius);
}
.game_title {
  border-radius: 0;
  text-align: center;
  width: 100%;
}
.game_img {
  --card-benchmark: 2.1rem;
  background-color: var(--cms-background-color-secondary);
  align-items: center;
  border-color: var(--advertisement-box-border-color);
  border-style: solid;
  border-width: var(--advertisement-box-border-width);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  border-radius: var(--advertisement-box-border-radius);
  flex-direction: column;
  height: var(--advertisement-box-height);
  justify-content: flex-end;
  position: relative;
  width: var(--advertisement-box-width);
  overflow: hidden;
  margin: var(--cardColSpacing) var(--cardColSpacing) 0.3rem
    var(--cardColSpacing);
  /* border: .08rem solid var(--theme-primary-color); */
  /* padding: .08rem; */
  box-sizing: border-box;
}
.iemgses {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.comnenGMens {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  padding: 0.06rem;
}
.eocnmesMens {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.conte_img {
  width: 100%;
  height: 100%;
  border-radius: var(--poster-box-border-radius);
  position: absolute;
  left: 0;
  top: 0;
}
.is_maintenance {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
}
.gy98qRcKCBtFIJuUTF8N {
  --label-game-status-height: calc(var(--card-benchmark) * 0.1524);
  --label-game-font-size: calc(var(--card-benchmark) * 0.081);
  --label-game-padding-width: calc(var(--label-game-status-height) * 0.3432);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--label-game-status-height);
  background: var(--skin__accent_2);
  width: auto;
  font-size: var(--label-game-font-size);
  color: #fff;
  padding-right: var(--label-game-padding-width);
  padding-left: var(--label-game-padding-width);
  border-bottom-right-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
}
.rQ13hS2C2xOiatmUjuvy {
  --favorited-icon-width: calc(var(--card-benchmark) * 0.28);
  --favorited-icon-height: calc(var(--card-benchmark) * 0.15);
  --favorited-icon-font-size: calc(var(--card-benchmark) * 0.086);
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--favorited-icon-width);
  box-sizing: border-box;
  height: var(--favorited-icon-height);
  color: #666;
  background-color: rgba(255, 255, 255, 0.6);
  font-size: var(--favorited-icon-font-size);
  border-radius: 0 var(--poster-box-border-radius) 0 0.1rem;
  position: absolute;
  z-index: 10;
  right: 0.05rem;
  top: 0.05rem;
}
.comnenGMens_ssme {
  opacity: 0.6;
  width: var(--favorited-icon-font-size) !important;
  height: var(--favorited-icon-font-size) !important;
}
._fconte {
  padding: 0.08rem;
  box-sizing: border-box;
}
._fconte .rQ13hS2C2xOiatmUjuvy_acction {
  width: 100%;
  height: auto;
  display: block;
}
/* .rQ13hS2C2xOiatmUjuvy_acction{
	-ms-flex-align: center;
	-ms-flex-pack: center;
	align-items: center;
	bottom: var(--favorited-icon-bottom);
	cursor: pointer;
	display: -ms-flexbox;
	display: flex;
	height: -webkit-fit-content;
	height: -moz-fit-content;
	height: fit-content;
	justify-content: center;
	left: var(--favorited-icon-left);
	line-height: 0;
	position: absolute;
	right: var(--favorited-icon-right);
	top: var(--favorited-icon-top);
	width: fit-content;
	z-index: 9;
	height: var(--favorited-icon-side);
	width: var(--favorited-icon-side);
} */
.vyJOQO76ijmamNiW1_eF {
  /* line-height: 2.694; */
  webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
  text-align: center;
  align-items: center;
  text-overflow: ellipsis;
  text-shadow: 0 0.02rem 0.04rem rgba(0, 0, 0, 0.3);
  vertical-align: middle;
  -ms-flex-pack: center;
  word-wrap: break-word;
  color: var(--theme-text-color-task-btn);
  display: -ms-flexbox;
  display: flex;
  font-size: var(--game-platform-name-font-size);
  height: var(--game-platform-name-height);
  justify-content: center;
  margin-bottom: var(--game-platform-name-margin-bottom);
  padding: var(--game-platform-name-padding);
  width: 100%;
  position: relative;
  position: absolute;
  bottom: 0;
  z-index: 9;
}

.conemNsmens {
  padding: var(--game-platform-name-padding);
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  color: var(--theme-text-color-task-btn);
  top: 0;
  left: 0;
  z-index: 9;
}
.conemNsmens ._top-name_1tpv4_23 {
  display: -webkit-box;
  max-width: 100%;
  overflow: hidden;
  font-family: MicrosoftYaHei;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  font-weight: 700;
  font-size: calc(var(--card-benchmark) * 0.1333);
  text-align: center;
  text-shadow: 0 0 0.05rem #03c3ff;
}
.conemNsmens ._bottom-name_1tpv4_38 {
  display: -webkit-box;
  max-width: 100%;
  overflow: hidden;
  font-family: MicrosoftYaHei;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  font-weight: 700;
  margin-top: calc(var(--card-benchmark) * 0.03333);
  font-size: calc(var(--card-benchmark) * 0.076);
  text-align: center;
  text-shadow: 0 0 0.05rem #03c3ff;
}
</style>
